import { trackCustomEventGoogleAnalytics } from "analytics/googleAnalytics/initiateGoogleAnalytics";
import { REACT_APP_NAME } from "config";
import { IDefaultCustomEventParams } from "interfaces/CustomAppEvents/customAppEventsParams.interface";
import { getProfileToLocalDB } from "utils/profile";
import { getIsPreSignUpFlowFlag } from "utils/signUp";
import { trackCustomEventFullStory } from "analytics/fullStory/initiateFullStory";

const genericCustomAppEventEventHandler = (
  customEventName: string,
  parameters: {
    [key: string]: any;
  } = {},
) => {
  const { fmcg_store_id: storeID = "", fmcg_account_id: accountID = "" } = getProfileToLocalDB();
  const defaultEventParams: IDefaultCustomEventParams = {
    Store_Id: storeID,
    User_Id: accountID,
    page_title: window.location.pathname,
    gs_app_name: REACT_APP_NAME,
    viewed_pricelist: !!getIsPreSignUpFlowFlag(),
    Timestamp: `${Math.floor(new Date().getTime() / 1000)}`,
  };

  const eventParameter = {
    ...defaultEventParams,
    ...(parameters || {}),
  };

  trackCustomEventGoogleAnalytics(customEventName, eventParameter);
  trackCustomEventFullStory(customEventName, eventParameter);
};

export default genericCustomAppEventEventHandler;
